import { ECustomFormatter } from './../Enums/ECustomFormatter';
import { IEntity } from "./IEntity";
import { ECustomSorter } from "../Enums/ECustomSorter";

export interface IWorkflowNode extends IEntity {
    name: string;
    parentid: number;
    iscollapsed: boolean;
    maxchildren: number | null;
    sortorder: number[] | null;
    memorybox: number;
    isfavorite: boolean;
    viewchronological: boolean;
    is_encrypted: boolean;
    options?: IWorkflowNodeOptions;
}

export interface IWorkflowNodeOptions {
    fontFamily?: number;
    abbreviate?: boolean;
    customSorter?: ECustomSorter;
    goToParentOnQuickSave?: boolean;
    customFormatter?: ECustomFormatter;
}

export const resourceNameWorkflowNode = `workflownode`;
